import { useDispatch, useSelector } from "react-redux";
import { ModalDialog, Stack, Button, Typography } from "@financeable-com-au/financeable-ui";
import { closeLodgeAIModal, lodgeAIErrorSelector } from "@/store/slices/lodgeAISlice";

const modalWidth = "480px";

const ErrorModal = () => {
  const lodgeAIError = useSelector(lodgeAIErrorSelector);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(closeLodgeAIModal());
  };

  return (
    <ModalDialog minWidth={modalWidth} maxWidth={modalWidth}>
      <Stack rowGap={5} alignItems="center">
        <Stack rowGap={2}>
          <Typography component="h2" id="modal-title" level="title-md" textAlign="center">
            {lodgeAIError?.title}
          </Typography>
          <Typography textAlign="center">{lodgeAIError?.message}</Typography>
        </Stack>
        <Button variant="secondary" fullWidth onClick={handleCloseModal}>
          Cancel
        </Button>
      </Stack>
    </ModalDialog>
  );
};

export { ErrorModal };
